import React from 'react';
import { useAuth } from '../../utils/AuthContext';
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import { Card, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { PremiumFeatureLock } from '../../components/premium/PremiumFeatureLock';

const AI_FEATURES = [
    {
        title: "AI Assistant",
        icon: "ri-robot-line",
        description: "Get instant answers to your financial questions and personalized advice.",
        link: "/ai/chat",
        color: "#506fd9"
    },
    {
        title: "Expense Forecast",
        icon: "ri-line-chart-line",
        description: "Predict future expenses using advanced AI algorithms.",
        link: "/ai/forecast",
        color: "#33d685"
    },
    {
        title: "Smart Insights",
        icon: "ri-lightbulb-flash-line",
        description: "Get AI-powered insights into your spending patterns and financial habits.",
        link: "/ai/insights",
        color: "#ffc107"
    },
    {
        title: "Budget Optimizer",
        icon: "ri-funds-box-line",
        description: "Let AI help you optimize your budget allocations for better financial outcomes.",
        link: "/ai/optimizer",
        color: "#ea4c89"
    },
    {
        title: "Debt Strategy",
        icon: "ri-money-dollar-circle-line",
        description: "Get AI-optimized debt repayment strategies to become debt-free faster.",
        link: "/ai/debt-strategy",
        color: "#1c96e9"
    }
];

export default function AIFeatures() {
    const { subscription } = useAuth();
    const isPremium = subscription === 'premium';

    if (!isPremium) {
        return (
            <React.Fragment>
                <Header />
                <div className="main main-app p-3 p-lg-4">
                    <div className="d-flex align-items-center justify-content-between mb-4">
                        <h4 className="main-title mb-0">AI Features</h4>
                    </div>

                    <PremiumFeatureLock 
                        title="AI-Powered Financial Tools"
                        description="Access our suite of AI-powered financial tools to optimize your finances. Upgrade to premium to unlock all features."
                    />

                </div>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <Header />
            <div className="main main-app p-3 p-lg-4">
                <div className="d-flex align-items-center justify-content-between mb-4">
                    <h4 className="main-title mb-0">AI Features</h4>
                </div>

                <Row className="g-3">
                    {AI_FEATURES.map((feature, index) => (
                        <Col key={index} md={6} lg={4}>
                            <Link to={feature.link} className="text-decoration-none">
                                <Card className="card-one h-100 feature-card">
                                    <Card.Body>
                                        <div className="d-flex align-items-center mb-3">
                                            <div 
                                                className="feature-icon me-3"
                                                style={{ 
                                                    backgroundColor: `${feature.color}20`,
                                                    color: feature.color 
                                                }}
                                            >
                                                <i className={`${feature.icon} fs-32`}></i>
                                            </div>
                                            <h6 className="card-title mb-0">{feature.title}</h6>
                                        </div>
                                        <p className="text-secondary mb-0">
                                            {feature.description}
                                        </p>
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                    ))}
                </Row>

            </div>
        </React.Fragment>
    );
} 